// extracted by mini-css-extract-plugin
export var actions = "_lv-d";
export var benefitCard = "_lv-a";
export var benefitIcon = "_lv-b";
export var benefitLabel = "_lv-c";
export var benefits = "_lv-9";
export var bodyText = "_lv-8";
export var closeButton = "_lv-2";
export var content = "_lv-3";
export var eyebrow = "_lv-4";
export var heading = "_lv-5";
export var image = "_lv-f";
export var imagePanel = "_lv-e";
export var modal = "_lv-0";
export var shell = "_lv-1";
export var title = "_lv-6";
export var titleOffer = "_lv-7";